type Props = {
    fill?: string;
    size?: number;
    className?: string;
};

export function WarningIcon({
    fill = 'currentColor',
    size = 24,
    className = '',
}: Props) {
    return (
        <svg
            className={className}
            xmlns="http://www.w3.org/2000/svg"
            height={`${size}px`}
            width={`${size}px`}
            fill={fill}
            viewBox="0 0 24 24"
            aria-hidden="true"
        >
            <path d="M0 0h24v24H0z" fill="none" />
            <path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z" />
        </svg>
    );
}
